import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'paper' | 'flat' | 'accent';
  pad?: 'sm' | 'md' | 'lg' | 'none';
  children?: ReactNode;
}

export function Card({
  variant = 'paper',
  pad = 'md',
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={clsx(
        'relative',
        variant === 'paper' && 'pb-card',
        variant === 'flat' && 'pb-card-flat',
        variant === 'accent' &&
          'rounded-pb-lg border border-pb-accent-line bg-pb-accent-soft',
        pad === 'sm' && 'p-3',
        pad === 'md' && 'p-4',
        pad === 'lg' && 'p-5',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
